import { render, staticRenderFns } from "./SingUp.vue?vue&type=template&id=31a7d4c9&scoped=true"
import script from "./SingUp.vue?vue&type=script&lang=js"
export * from "./SingUp.vue?vue&type=script&lang=js"
import style0 from "./SingUp.vue?vue&type=style&index=0&id=31a7d4c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a7d4c9",
  null
  
)

export default component.exports